export default __webpack_public_path__ + "static/media/au.1bffebac.svg";